import { NetworkUnauthorizedError } from '@rhino-project/core/lib';

const MAX_ATTEMPTS = 3;

/**
 * React Query retry predicate for queries.
 *
 * A 4xx is a verdict rather than a blip, so retrying only delays the outcome —
 * a deleted record's 404 would otherwise spend three extra round trips behind a
 * spinner before the page can report that it is gone. Errors carrying no status
 * (network drops, aborted requests) keep the default retries.
 */
export const retryUnlessClientError = (failureCount: number, error: Error) => {
  if (error instanceof NetworkUnauthorizedError) return false;

  const { status } = error as { status?: number };
  if (status !== undefined && status < 500) return false;

  return failureCount < MAX_ATTEMPTS;
};
